module.exports = __webpack_public_path__ + "img/置顶@2x.26515fc5.png";